<template>
  <section class="site_hero" :style="{ backgroundImage: `url(${image})` }">
    <div class="site_container">
      <p v-if="eyebrow" v-reveal="50" class="site_eyebrow">{{ eyebrow }}</p>
      <h1 v-reveal="150">{{ title }}</h1>
      <p v-if="lead" v-reveal="950" class="site_hero_lead">{{ lead }}</p>

      <slot />

      <a v-if="scrollTo" v-reveal:down="1350" class="site_hero_scroll" :href="`#${scrollTo}`" aria-label="Przejdź niżej">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="7 13 12 18 17 13" />
          <polyline points="7 6 12 11 17 6" />
        </svg>
      </a>
    </div>
  </section>
</template>

<script>
// The title band at the top of a page: photo, eyebrow, heading, lead, and an
// optional chevron that scrolls to the first section.

export default {
  name: 'SiteHero',

  props: {
    image: { type: String, required: true },
    title: { type: String, required: true },
    eyebrow: { type: String, default: '' },
    lead: { type: String, default: '' },
    scrollTo: { type: String, default: '' },
  },
}
</script>
